import React, { useState, useEffect, useMemo, useRef } from "react";
import CheckoutDetails from "../../components/Checkout/CheckoutDetails";
import DeliveryView from "../../components/Checkout/DeliveryView";
import Header from "../../components/Header/Header";
import AddNote from "../../components/Checkout/AddNote";
import Payment from "../../components/Checkout/Payment";
import HamburgerMenu from "../../components/Sidebar/HamburgerMenu";
import { useSelector, useDispatch } from "react-redux";
import Konsole from "../../utils/konsole/Konsole";
import GetAllOrderApi from "../../api/allOrderApi";
import { SETALLORDERDATA } from "../../redux/features/AllOrder";
import { GetAllAddress } from "../../api/GetAddress";
import { DeliveryPriceAndOrderFee } from "../../utils/DeliveryPriceAndOrderFee";
import { setSelectedAddress } from "../../redux/features/CheckoutAddress";
import { SETISCOMPLETE } from "../../redux/features/common";
import NewPayment from "../../components/Stripe-Payment/New-Payment/NewPayment";
import { IsNullUndefine } from "../../utils/helper";
import {
  CheckStoreAreaDeliveryAvailable,
  CheckStoreRadiousDeliveryAvailable,
} from "../../utils/CheckDeliveryAvailable";
import { setMinimumPriceAndAddressData } from "../../components/Checkout/GoogleAddress/googleAddressutils";
import useCheckBlockPostCode from "../../hooks/useCheckBlockPostCode";
import { useTranslation } from "react-i18next";
import NewPaymentWithRazorpay from "../../components/Stripe-Payment/New-Payment/NewPaymentWithRazorpay";
import CouponCode from "../../components/Discount/CouponCode";
import Promotions from "../../components/Discount/Promotions";
import useAllApiCall from "../../hooks/useAllApiCall";
import useLogoFevIcon from "../../hooks/useLogoFevIcon";
import useStoreStatus from "../../hooks/useStoreStatus";
export default function Checkout() {
  const {marketData}=useStoreStatus()
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {logo,fevicon}=useLogoFevIcon()

  const { getStoreInfo, isStoreDataFetched } = useAllApiCall();
  const {
    store: { selectedStore },
    allOrder: { orders },
    checkoutAddress,
    addressData: { address },
  }: any = useSelector((state: any) => state);
  const [sidebar, setSidebar] = useState(false);
  const isApiCall = useRef(false)
  const IsBlockPostCode = useCheckBlockPostCode();
  const hasSelectedAddress = useMemo(() => {
    const hasAddress =
      Object.keys(checkoutAddress?.selectedAddress)?.length > 0;
    return hasAddress;
  }, [checkoutAddress, selectedStore]);

  useEffect(() => {
    // console.log('fevIconUrl', fevIconUrl)
    const link: HTMLLinkElement =
      document.querySelector("link[rel='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "icon";
    link.href = fevicon;
    document.head.appendChild(link);
  }, [selectedStore,fevicon]);

  // console.log('hasSelectedAddress', address, address?.length, hasSelectedAddress);
  // console.log('orders', orders)

  useEffect(() => {
    if (isApiCall.current == false) {
      isApiCall.current = true;

      getStoreInfo();
    }


    return () => {
      isApiCall.current = false
    }
  }, [])

  useEffect(() => {
    if (
      orders?.length > 0 &&
      address?.length > 0 &&
      hasSelectedAddress == false
    ) {
      updateAddressOfRecentOrder(orders, address);
    } else if (hasSelectedAddress == false) {
      fetchOrderNAddressDetail();
    }
  }, []);

  // @@ fetch address and order details
  const fetchOrderNAddressDetail = async () => {
    try {
      const [orderRes, addressRes] = await Promise.all([
        GetAllOrderApi(),
        GetAllAddress(dispatch),
      ]);
      const { order_list } = orderRes;
      // console.log("order_list", order_list, "addressRes", addressRes);

      if (orderRes?.order_list?.length > 0 && addressRes?.length > 0) {
        updateAddressOfRecentOrder(orderRes?.order_list, addressRes);
      }
      dispatch(SETALLORDERDATA(order_list));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // @@ address select of last order

  const updateAddressOfRecentOrder = async (orderList: any, address: any) => {
    if (orderList.length > 0 && address?.length > 0) {
      let recentOrder = orderList?.find(
        (i: any) =>
          i.order_category == 3 &&
          !IsNullUndefine(i?.address_lat) &&
          !IsNullUndefine(i.address_long)
      );
      // console.log('eeeeee', recentOrder);

      // for zip code address
      // if (recentOrder) {
      //   const data = await DeliveryPriceAndOrderFee(recentOrder?.zip_code, selectedStore, dispatch);
      //   if (!data || data?.status == false) {
      //     // delivery not allow
      //     return;
      //   }
      //   const findAddress = address?.find((i: any) => i.zip_code == recentOrder?.zip_code && i.full_address == recentOrder?.delivery_address)
      //   if (findAddress && data?.status) {
      //     dispatch(
      //       setSelectedAddress({
      //         ...findAddress,
      //         distance: data?.distance || '',
      //         latitude: data?.latitude,
      //         longitude: data?.longitude,
      //         price: data?.price,
      //       })
      //     );
      //     dispatch(SETISCOMPLETE(true));
      //   } else {
      //     dispatch(SETISCOMPLETE(false));
      //   }
      // }

      // @@ for area base
      if (recentOrder) {
        let latLng = {
          lat: Number(recentOrder?.address_lat),
          lng: Number(recentOrder?.address_long),
        };
        let isDeliveryAllow = CheckStoreAreaDeliveryAvailable(
          latLng,
          selectedStore
        );

        if (!isDeliveryAllow?.status) {
          return;
        }
        const findAddress = address?.find(
          (i: any) =>
            i.zip_code == recentOrder?.zip_code &&
            i.full_address == recentOrder?.delivery_address
        );
        if (findAddress) {
          let matchedData = isDeliveryAllow?.matchedAreaData;
          setMinimumPriceAndAddressData(
            dispatch,
            matchedData?.minimum_order_fees,
            {
              ...findAddress,
              price: matchedData?.price,
            }
          );
        }
      }
    }
  };

  const handleSidebar = () => {
    setSidebar(!sidebar);
  };

  return (
    <>
      {/* <LogoHeader /> */}
      <div className="topheader">
        <div className="pageHeader">
          <Header handleSidebar={handleSidebar} />
        </div>
      </div>

      <div
        className={`${sidebar ? "left-0" : "left-[-50rem]"
          } md:hidden block absolute h-screen w-screen transition-all z-[51] bg-white`}
      >
        <HamburgerMenu handleSidebar={handleSidebar} sidebar={sidebar} />
      </div>

      {!sidebar && (
        <div className="bg-[#F3F5FA] ">
          <form
            onSubmit={(e: any) => e.preventDefault()}
            className="md:pt-[90px] md:px-10 px-0 pt-16 container mx-auto"
          >
            <div className="flex gap-3 flex-wrap md:flex-nowrap">
              <div className="lg:w-2/3 w-full md:h-[calc(100vh-6rem)] h-auto scroll-hidden overflow-y-auto overflow-x-visible">
                {/* @@ this is for delivery view address and schedule */}
                {marketData?.pre ? (
                  <div className="m-2 ms-3 me-3 w-auto text-center bg-[#34558B] text-white px-4 py-1 rounded-full text-sm font-medium block md:hidden">
                    {t("MyOrders.preOrder")}
                  </div>
                ) : null}
                <DeliveryView />
                {/* @@ this is for delivery view address and schedule */}

                {/* @@ add Notes  */}
                {/* <AddNote /> */}

                {/* @@ Payment part */}
                <AddNote />
                <CouponCode />
                <div className="md:block hidden">



                  <NewPaymentWithRazorpay />
                </div>
              </div>
              {/* @@ right side checkout details */}
              <div className="lg:w-2/6 w-full md:h-[calc(100vh-6rem)] h-auto scroll-hidden overflow-y-auto overflow-x-visible">
                <CheckoutDetails />
              </div>
            </div>
          </form>
        </div>
      )}
    </>
  );
}
